import React from 'react';
import { useSelector } from 'react-redux';

import EarthIcon from '@icons/new/earth.svg';
import RibbonIcon from '@icons/new/ribbon.svg';
import SearchIcon from '@icons/new/search.svg';

import { getTranslationsState } from '@redux/selectors';

import styles from './CarRentalFeatures.module.scss';

const CarRentalFeatures: React.FC = () => {
  const translations = useSelector(getTranslationsState);

  const features = [
    {
      Icon: <EarthIcon />,
      title: translations.car_rentals_feature_search_title,
      description: translations.car_rentals_feature_search_description,
    },
    {
      Icon: <SearchIcon />,
      title: translations.car_rentals_feature_view_title,
      description: translations.car_rentals_feature_view_description,
    },
    {
      Icon: <RibbonIcon />,
      title: translations.car_rentals_feature_flexible_title,
      description: translations.car_rentals_feature_flexible_description,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.featuresGrid}>
        {features.map((feature) => (
          <div key={feature.title} className={styles.featureCard}>
            {feature.Icon}
            <h3 className={styles.title}>{feature.title}</h3>
            <p className={styles.description}>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarRentalFeatures;
